import { useContext } from "react";

import { JOURNEY_CAPTURE_FLAG } from "@/components/AIAutomation/constants";
import { isSessionObserveAvailable } from "@/helpers/electron-helper";
import { AppContext } from "@/stores/appStore";
import { useFeatureFlag } from "@/stores/contexts/FeatureFlagsContext";

/**
 * Which AI surface owns this hire: session-wide capture, or the older per-step opt-in.
 *
 * The flag says who should get it, the capability whether this build can deliver it. Deliberately
 * excludes whether anything may be offered yet -- conflating the two would read as "not in the
 * experience" while the answer was merely unknown, and the per-step prompt would fill the gap. See
 * {@link useIsAiOfferable}.
 */
export const useIsJourneyCaptureAvailable = (): boolean =>
  useFeatureFlag(JOURNEY_CAPTURE_FLAG) && isSessionObserveAvailable();

/**
 * Whether any AI feature may be put to the hire yet.
 *
 * Every AI surface pins a regional runtime for the session's life, so offering one before the hiring
 * region is known would mean guessing, and a guess of US for an EU hire is a residency breach.
 * Settled is not known: a record naming no country releases the wait and takes the default.
 */
export const useIsAiOfferable = (): boolean => {
  const { state } = useContext(AppContext);
  return state.isHiringRegionSettled;
};
